
export default {
  props: {
    features: {
      required: true,
    },
  },
}
